<script>
import { generateChart } from 'vue-chartjs'
const HorizontalBar = generateChart('horizontal-bar', 'horizontalBar')

export default {
  name: 'bar-chart',
  extends: HorizontalBar,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    barThickness: {
      type: Number,
      default: 4,
    },
    paddingBottom: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    datasets() {
      return this.chartdata
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 0,
            bottom: this.paddingBottom,
          },
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                display: false,
              },
              gridLines: {
                display: false,
                drawBorder: false,
              },
            },
          ],
          yAxes: [
            {
              maxBarThickness: this.barThickness,
              barThickness: this.barThickness,
              barPercentage: 1,
              categoryPercentage: 1,
              ticks: {
                display: false,
              },
              gridLines: {
                display: false,
                drawBorder: false,
              },
            },
          ],
        },
        tooltips: {
          xPadding: 13,
          yPadding: 6,
          cornerRadius: 0,
          bodyFontFamily: "'Roboto', sans-serif",
        },
      }
    },
  },
  mounted() {
    this.renderBarChart()
  },
  methods: {
    renderBarChart() {
      this.renderChart(this.chartdata, this.options, this.charttype)
    },
  },
  watch: {
    chartdata() {
      this.renderBarChart()
    },
  },
}
</script>
